export { default } from './EmbedScripts'
